import * as React from 'react';
import './DrawerComponentTwo.css';
import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import { getLoggedInFlag, getMUICache, getEndpoint, fetchAnchorValue, safeCharAt, getAnchorUrl } from "../../../common/utils"
import ListItemButton from '@mui/joy/ListItemButton';
import { Button, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import InputAdornment from '@mui/material/InputAdornment';
import { CacheProvider } from '@emotion/react';
import { handleSearchClick, getLoggedUserName, logoutUser, getLoggedUserEmail } from "../../../common/utils";

export default function DrawerComponentTwo(props) {

  console.log("Inside DrawerComponentTwo props", props);

  const { toggleMainMenu, menuItems, domainUrl, HamburgerTextColor, HamburgerBgColor, hostId, anchorLinksValue } = props;
  const [searchValue, setSearchValue] = useState("");
  const [loggedUserName, setLoggedUserName] = useState("");
  const [loggedUserEmail, setLoggedUserEmail] = useState("");
  const [loginLink, setLoginLink] = useState("");
  const [loginEnabled, setLoginEnabled] = useState(false);
  // const [menuOpen, setMenuOpen] = useState(false); // Track menu open/close state

  // const endpointHostId = getEndpoint(props, "HEADER_MENU_API");
  // const hostId = endpointHostId.queryParams.hostId;

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearchClick(searchValue, hostId);
    }
  }

  if (!loginEnabled && props && props.transportData && props.transportData.isLoginEnabled) {
    setLoginEnabled(props.transportData.isLoginEnabled);
  }


  const toggleMenu = () => {
    document.body.classList.remove("modal-open");
  };
  useEffect(() => {
    setLoggedUserName(getLoggedUserName());
    setLoggedUserEmail(getLoggedUserEmail());
    setLoginLink("/login?url=" + encodeURIComponent(window.location.href));

    if (!loginEnabled && props && props.transportData && props.transportData.isLoginEnabled) {
      setLoginEnabled(props.transportData.isLoginEnabled);
    }
    setLoginEnabled(getLoggedInFlag());
  }, []);

  // Condition: Add class if loggedUserEmail is true
  const hasUserEmail = !!loggedUserEmail;
  const getLoginString = () => {
    if (loginEnabled) {
      if (loggedUserName) {
        return (
          <>
            <div className="themeTwoWelcomeWrapperMobile">
              <button className="themeTwoAfterLoginButtonMobile">
                {safeCharAt(loggedUserName)}
              </button>

              <div className="ThemeTwoWelcomeUserDetails">
                <li className="UserNameAfterLogIn">{loggedUserName}</li>
                <li className="UserEmailAfterLogIn">{loggedUserEmail}</li>
              </div>
            </div>
            {/* <div className="themeTwoListLogMobile">
                  <li>
                    {" "}
                    <a onClick={logoutUser} href="javascript:void(0)">
                      Logout
                    </a>
                  </li>
                </div> */}
          </>
        );
      }
      return (
        <div className="themeTwoLoginWrapperMobile">
          <a href={loginLink} className="themeTwoLoginAnchorMobile">
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.182 17.7313L20.1766 17.7259L20.1711 17.7207L20.014 17.573L20.0085 17.5678L20.0028 17.5627C19.2675 16.9121 18.3175 16.55 17.33 16.55H8.66336H8.65574L8.64812 16.5502L8.43264 16.5568L8.42502 16.557L8.41741 16.5575C7.43743 16.6173 6.50959 17.0331 5.81137 17.7313C5.05497 18.4877 4.63003 19.5136 4.63003 20.5833V22.7345L4.62596 22.8C4.60245 22.9417 4.47853 23.05 4.33003 23.05C4.16434 23.05 4.03003 22.9157 4.03003 22.75V20.5895L4.03603 20.3475C4.09422 19.2046 4.57392 18.1202 5.3871 17.3071L5.3871 17.3071C6.25601 16.4381 7.43453 15.95 8.66336 15.95H17.33C18.5588 15.95 19.7373 16.4381 20.6063 17.3071C21.4752 18.176 21.9633 19.3545 21.9633 20.5833V22.7345L21.9593 22.8C21.9358 22.9417 21.8119 23.05 21.6633 23.05C21.4977 23.05 21.3633 22.9157 21.3633 22.75V20.5833C21.3633 19.5136 20.9385 18.4877 20.182 17.7313Z"
                fill="#666666"
                stroke="#666666"
              />
              <path
                d="M13.2107 11.6113L13.2107 11.6114L13.2242 11.6107C15.3493 11.4958 17.0367 9.73679 17.0367 7.58333H17.0368L17.0365 7.56985L17.0313 7.37598L17.0314 7.37598L17.0307 7.36247C16.9158 5.23741 15.1568 3.55 13.0033 3.55V3.54982L12.9898 3.55018L12.796 3.55541L12.796 3.55522L12.7825 3.55595C10.6574 3.67086 8.97 5.42987 8.97 7.58333H8.96981L8.97018 7.59681L8.9754 7.79067L8.97522 7.79068L8.97595 7.80419C9.09086 9.92926 10.8499 11.6167 13.0033 11.6167V11.6168L13.0168 11.6165L13.2107 11.6113ZM12.802 12.2124C10.3384 12.1073 8.37266 10.0776 8.37 7.58838L8.37428 7.38204C8.4794 4.91837 10.5091 2.95266 12.9983 2.95L13.2046 2.95428C15.6683 3.0594 17.634 5.08911 17.6367 7.57828L17.6324 7.78462C17.5273 10.2483 15.4976 12.214 13.0084 12.2167L12.802 12.2124Z"
                fill="#666666"
                stroke="#666666"
              />
            </svg>{" "}
            <span>login</span>
          </a>
        </div>
      );
    }
  };

  return (
    <>
      {

        <CacheProvider value={getMUICache()}>
          <div className="navoverlay" />
          <div className='withLogoutButtonThemeTwo'>
            <Box className="sidenav mobileSideNav" style={{ backgroundColor: HamburgerBgColor }} sx={{ top: "0", position: "fixed", zIndex: "9" }} role="presentation" >
              <Button className="closebtn" onClick={() => { toggleMainMenu(); toggleMenu(); }}><CloseIcon /></Button>
              {/* <div class="sidemenu-search-box">
                            
                            <div className="form-group">
                                <TextField id="" placeholder='Type Search here' onKeyPress={(e) => handleKeyPress(e)}  onChange={e => setSearchValue(e.target.value)} type='search' variant="filled" fullWidth
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end"><SearchIcon onClick={() => handleSearchClick(searchValue)} /></InputAdornment>
                                    }}
                                />
                            </div>
                        </div> */}
              <List orientation="horizontal"
                sx={{
                  '--List-padding': '0px',
                  '--List-gap': '0px',
                  '--ListItem-paddingX': '0px',
                  '--ListItem-paddingY': '0px',
                  padding: "0"
                }}>
                <div className="themeTwoMainLoginFunctionWrapMobile">
                  {getLoginString()}
                </div>
                {
                  (Array.isArray(menuItems) ? menuItems : []).map((val, index) => {
                    let path = val.path;
                    if (val.type === 2) {
                      path = '/tags/' + (val.tagpath !== undefined ? val.tagpath : '');
                    }
                    return <ListItem key={index} role="none">
                      <ListItemButton component="a" href={getAnchorUrl(domainUrl, path)} target={fetchAnchorValue(anchorLinksValue, path)} style={{ color: HamburgerTextColor }}>{val.name}</ListItemButton>
                      {val.sections &&
                        val.sections.map((dataItem, index) => {
                          let pathInternal = dataItem.path;
                          if (dataItem.type === 2) {
                            pathInternal = '/tags/' + (dataItem.tagpath !== undefined ? dataItem.tagpath : '');
                          }
                          return <List key={index} component="ul" disablePadding className='sub-menu'>
                            <ListItem>
                              <ListItemButton key={'1_' + index} component="a" href={getAnchorUrl(domainUrl, pathInternal)} target={fetchAnchorValue(anchorLinksValue, pathInternal)} style={{ color: HamburgerTextColor }}>{dataItem.name}</ListItemButton>
                            </ListItem>
                          </List>
                        })

                      }
                    </ListItem>
                  })
                }
              </List>

            </Box>
            <div className="themeTwoListLogMobile">
              <li>
                {" "}
                <a onClick={logoutUser} href="javascript:void(0)" className={`logoutLink ${hasUserEmail ? "emailExists" : ""}`}>Logout</a>
              </li>
            </div>
          </div>
        </CacheProvider>
      }
    </>
  );
}